import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { SelectionModel } from '@angular/cdk/collections';
import { DatePipe, formatDate } from '@angular/common';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { CustomerService } from '../_services/customer.service';
import { AccountService } from '../_services/account.service';
import { InvoicesService } from '../_services/invoices.service';
import { MatSort, MatPaginator, MatTableDataSource } from '@angular/material';
import { ExcelService } from '../_helpers/index';

import { ParameterData } from '../_helpers/index';
import { Router, ActivatedRoute } from '@angular/router';
import { Status, Overduedate, ExpirationRank, Creation } from '../_enums/invoice';
import { DataService } from '../_helpers/dataservice.service'
import { accountPSPCreation, accountVirtualType } from '../_enums/account';
import { AuthService } from '../_services/auth.service';
import { Operation } from '../_models';

@Component({
  selector: 'accountsoperationvirtual',
  templateUrl: './accountoperationvirtual.component.html',
  styleUrls: ['../../assets/css/customer-list-table.css']
})

export class AccountsOperationVirtualComponent implements OnInit, OnDestroy {

  public customer_public_id: string;
  public accounts_operation_public_id: string;

  excelExportData: any;

  ddlAccountType: any[];
  ddlAccountCreation: any[];

  searchFilterForm: FormGroup;
  searchRangoFilterForm: FormGroup;
  displayedColumns: string[] = ['created', 'reference', 'type', 'previous_balance', 'transaction.total', 'new_balance', 'status'];
  dataSourceAccVirtualList = new MatTableDataSource();
  selection = new SelectionModel<any>(true, []);
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  filterValue;
  customerPublic_key;
  isRangoVisiable = false;
  auth0Profile: any;
  /** This is Constructor function which is used to initialize the class variables and objects; 
   */
  constructor
    (
      private router: Router, private formBuilder: FormBuilder
      , private _fb: FormBuilder
      , private excelService: ExcelService
      , private parameterData: ParameterData, private dataService: DataService
      , private customerService: CustomerService, private accountService: AccountService
      , private invoicesService: InvoicesService
      , private creation: Creation
      , private expirationRank: ExpirationRank
      , private overduedate: Overduedate
      , private status: Status
      , private datePipe: DatePipe
      , private readonly activatedRoute: ActivatedRoute
      , private auth: AuthService
      , private _accountpspcreation: accountPSPCreation
      , private _acctype: accountVirtualType

    ) {

    this.ddlAccountCreation = _accountpspcreation._accountpspcreation;
    this.ddlAccountType = _acctype._accountVirtualType;



  }//end 




  /** This function is used to work the text filter above the grid; 
   */
  applyFilter() {

    this.filterValue = this.searchFilterForm.controls.searchText.value;
    this.filterValue = this.filterValue.trim();
    this.filterValue = this.filterValue.toLowerCase();
    this.dataSourceAccVirtualList.filter = this.filterValue;
  }//end


  /** This is ngOnInit function called after initialising the component; 
 */
  ngOnInit() {

    let browserStorage1 = (localStorage.getItem('isCorporate') == 'undefined') ? null : localStorage;
    if (browserStorage1 == null) {
      let browserStorage = localStorage.getItem('companyId');
      if (browserStorage == null || browserStorage == '' || browserStorage == undefined) {
        this.router.navigate(['/home']);
      }
      else {
        this.customer_public_id = localStorage.getItem('companyId');

      }
    }
    else {
      this.customer_public_id = localStorage.getItem('subcompanyId');
    }


    //used to retrieve the customer public id
    let params: any = this.activatedRoute.snapshot.params;
    this.accounts_operation_public_id = params.id;

    this.searchFilterForm = this.formBuilder.group({
      searchText: ['', Validators.required]
    });

    this.searchRangoFilterForm = this._fb.group({
      searchFromDate: [''],
      searchToDate: ['']
    });

    this.paginator._intl.itemsPerPageLabel = "Registros por página";
    this.paginator._intl.nextPageLabel = "siguiente página";
    this.paginator._intl.lastPageLabel = "última página";
    this.paginator._intl.previousPageLabel = "anterior página";
    this.paginator._intl.firstPageLabel = "primera página";

    this.GetAccountsOperationsList();
    this.dataSourceAccVirtualList.paginator = this.paginator;
    this.dataSourceAccVirtualList.sort = this.sort;

  }//end

  ngOnDestroy() {

  }//end


  /** This function is used to get the invoices list from the service; 
 * it accepts the param customerId
 */
  GetAccountsOperationsList() {
    this.accountService.getAccountOperationList(this.accounts_operation_public_id, '').subscribe(data => {
      let resources = data["data"];
      this.dataSourceAccVirtualList.data = resources;
      this.excelExportData = resources;

    },
      error => {
        console.log('Failed! while trying to get the Accounts Operation Virtual list. ' + error);
      });
  }//end





  /** This function is used to export the invoices list to the excel file; 
   * it reads the data from the variable excelExportData which is assigened when the lits bind in to the grid
   */
  exportAsXLSX() {
    this.excelService.exportAsExcelFile(this.excelExportData, 'AccountsVirtualList');
  }//end


  /** This function is used to filter the Account list based on Creation Detail wise; 
   * it accepts the param select status value
   */
  filterAccountTypeDetails(accounttype) {

    if (accounttype == this.ddlAccountType[0].value) {
      this.dataSourceAccVirtualList.filter = '';
    }
    else {
      this.dataSourceAccVirtualList.filter = '';
      this.dataSourceAccVirtualList.filterPredicate = (data: Operation, filter: string) =>
        data.type == accounttype;
      this.dataSourceAccVirtualList.filter = accounttype;
    }

  }//end

  /*
     * This function is used to filter the invoices list based on Creation details based; 
     * it accepts the param select Creation Date values      
     */

  filterAccountCreationDetails(creation) {

    var currentDate = new Date();

    var currentweekFirstDate = new Date();
    var currentweekLastDate = new Date();

    var lastweekFirstDate = new Date();
    var lastweekLastDate = new Date();

    currentweekFirstDate.setDate(currentweekFirstDate.getDate() - currentweekFirstDate.getDay());
    currentweekLastDate.setDate(currentweekFirstDate.getDate() + 7);

    var currentmonthFirstDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
    var currentmonthLastDate = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);

    var lastmonthFirstDate = new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, 1);
    var lastmonthLastDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), 0);

    lastweekFirstDate.setDate(currentweekFirstDate.getDate() - 7);
    lastweekLastDate.setDate(lastweekFirstDate.getDate() + 6);



    // All Datas Condition
    if (creation == 0) {
      this.dataSourceAccVirtualList.filter = '';
    }

    // Current Month Filter Condition
    if (creation == 1) {
      this.dataSourceAccVirtualList.filter = '';
      let CurrentmonthFirstDate = formatDate(currentmonthFirstDate, 'yyyy-MM-dd 00:00:00', 'en-US');
      let CurrentmonthEndDate = formatDate(currentmonthLastDate, 'yyyy-MM-dd 23:59:00', 'en-US');
      this.dataSourceAccVirtualList.filterPredicate = (data: Operation, filter: string) =>
        data.created >= CurrentmonthFirstDate && data.created <= CurrentmonthEndDate;

    }

    // Current Week Filter Condition
    if (creation == 2) {
      this.dataSourceAccVirtualList.filter = '';
      let WeekstartDate = formatDate(currentweekFirstDate, 'yyyy-MM-dd 00:00:00', 'en-US');
      let WeekendDate = formatDate(currentweekLastDate, 'yyyy-MM-dd 23:59:00', 'en-US');
      this.dataSourceAccVirtualList.filterPredicate = (data: Operation, filter: string) =>
        data.created >= WeekstartDate && data.created <= WeekendDate;

    }

    // Today Filter Condition
    if (creation == 3) {
      this.dataSourceAccVirtualList.filter = '';
      currentDate.setDate(currentDate.getDate());
      let startDate = formatDate(currentDate, 'yyyy-MM-dd 00:00:00', 'en-US');
      let endDate = formatDate(currentDate, 'yyyy-MM-dd 23:59:00', 'en-US');
      this.dataSourceAccVirtualList.filterPredicate = (data: Operation, filter: string) =>
        data.created >= startDate && data.created <= endDate;
    }

    // Yesterday Filter Condition
    if (creation == 4) {
      this.dataSourceAccVirtualList.filter = '';
      currentDate.setDate(currentDate.getDate() - 1);
      let startDate = formatDate(currentDate, 'yyyy-MM-dd 00:00:00', 'en-US');
      let endDate = formatDate(currentDate, 'yyyy-MM-dd 23:59:00', 'en-US');
      this.dataSourceAccVirtualList.filterPredicate = (data: Operation, filter: string) =>
        data.created >= startDate && data.created <= endDate;
    }


    // Last Week Filter Condition
    if (creation == 5) {
      this.dataSourceAccVirtualList.filter = '';

      let lastWeekstartDate = formatDate(lastweekFirstDate, 'yyyy-MM-dd 00:00:00', 'en-US');
      let lastWeekendDate = formatDate(lastweekLastDate, 'yyyy-MM-dd 23:59:00', 'en-US');


      this.dataSourceAccVirtualList.filterPredicate = (data: Operation, filter: string) =>
        data.created >= lastWeekstartDate && data.created <= lastWeekendDate;

    }

    // Last Month Filter Condition
    if (creation == 6) {
      this.dataSourceAccVirtualList.filter = '';
      let LastmonthFirstDate = formatDate(lastmonthFirstDate, 'yyyy-MM-dd 00:00:00', 'en-US');
      let LastmonthEndDate = formatDate(lastmonthLastDate, 'yyyy-MM-dd 23:59:00', 'en-US');
      this.dataSourceAccVirtualList.filterPredicate = (data: Operation, filter: string) =>
        data.created >= LastmonthFirstDate && data.created <= LastmonthEndDate;

    }
    if (creation != 0) {
      this.dataSourceAccVirtualList.filter = '2018-10-24 01:59:45';
    }


    // Range Filter Condition
    if (creation == 7) {
      this.isRangoVisiable = true;
    }
    else {
      this.isRangoVisiable = false;
    }
  }//end

}//end class


